import {getCountries, getCountryCallingCode, parsePhoneNumberWithError} from 'libphonenumber-js';

/**
 * Get countries calling codes
 *
 * @returns {{countryCode: string, callingCode: string}[]} the calling codes
 */
export const getCountriesCallingCode = () => {
  return getCountries().map((countryCode) => {
    return {
      countryCode,
      callingCode: `+${getCountryCallingCode(countryCode)}`
    };
  });
};

/**
 * Formats a phone number in E.164 standard
 *
 * @param number the phone number
 * @param countryCode the country code
 * @returns {string} the formatted phone number
 */
export const formatPhoneNumberAsInternational = (number, countryCode) => {
  if (!number || !countryCode) return '';
  try {
    /** @type {PhoneNumber} */
    const phoneNumber = parsePhoneNumberWithError(number, countryCode);
    return phoneNumber.formatInternational();
  } catch (error) {
    return `+${getCountryCallingCode(countryCode)}${number}`;
  }
}

